import {
  SheetMappingTableBuilder,
  SheetTableMapBuilder,
  ConfirmDialogBuilder,
} from 'components/DynamicScreen/TableWidget/SheetTableMapForm';
import {
  multiSheetVerifyTable,
  verifyTemplateGenerator,
} from 'components/DynamicScreen/TableWidget/VerifyTableGenerator';
import { isEmpty } from 'lodash';
import { apiGet, apiPost, apiPut, apiDelete } from './api';
import { fetchDynamicJSON } from './dynamicjson';
import { getSheetHeaders, workSheetReader } from './files';
import SMDIalogControl, {
  SMChatDIalogControl,
  SMLocationDIalogControl,
  SMConfirmDialogControl,
} from './SMDialogControl';
import SMDialogControl from './SMDialogControl';
import { persistentStore } from './storage';

// const linkHandlers = [
//   {
//     pattern: /^spacemonk:.+\/task\/\d\/delete$/,  // Info: regex relatable for checklist task delete.
//     operation: ({deeplink, baseURL, formData}) =>
//       apiPut(
//         deeplinkToURL(deeplink), // TODO: remove '/v2' hack
//         {}
//       ).then(({userMessage: message, refreshDeeplink}) => ({ // TODO: should be 'userMessage'
//         url: deeplinkToURL(refreshDeeplink, baseURL),
//         message
//       }))
//   },
//   {
//     pattern: /^spacemonk:.+\/task\/\d\/update$/,  // Info: regex relatable for checklist task edit and update.
//     operation: ({deeplink, baseURL, formData}) =>
//       apiPut(
//         deeplinkToURL(deeplink), // TODO: remove '/v2' hack
//         {body: formData}
//       ).then(({userMessage: message, refreshDeeplink}) => ({ // TODO: should be 'userMessage'
//         url: deeplinkToURL(refreshDeeplink, baseURL),
//         message
//       }))
//   },
//   {
//     pattern: /^spacemonk:.+\/dashboard\/add\/[^/]+\/.+/, // ensuring that it does not match `.../add/${type}`
//     operation: ({deeplink}) => {
//       const parts = deeplink.split('/');
//       const [type, id] = parts.slice(-2);
//       deeplink = parts.slice(0, -2).join('/');
//       return apiPost(
//         deeplinkToURL(deeplink),
//         {
//           body: { dashboardItems: [ { id, type}, ] }
//         }
//       ).then(({userMessage: message, refreshDeeplink}) => ({
//         url: deeplinkToURL(refreshDeeplink, '/list'), // TODO: avoid hardcoding to /list
//         message
//       }));
//     }
//   },
//   {
//     pattern: /^spacemonk:.+\/dashboard\/add\/?$/,
//     operation: ({deeplink}) => ({
//       url: deeplinkToURL(deeplink, '/list') // TODO: avoid hardcoding to /list
//     })
//   },
//   {
//     pattern: /^spacemonk:.+\/(add\?|add$|edit$)/,
//     operation: ({deeplink}) =>({
//       url: deeplinkToURL(deeplink, '/dialog')
//     })
//   },
//   {
//     pattern: /^spacemonk:.+\/submit$/,
//     operation: ({deeplink, baseURL, formData}) =>
//       apiPost(
//         deeplinkToURL(deeplink.replace(/\/submit$/, '').replace(/\/v2\//, '/')), // TODO: remove '/v2' hack
//         {body: formData}
//       ).then(({userMessage: message, refreshDeeplink}) => ({
//         url: deeplinkToURL(refreshDeeplink, baseURL),
//         message
//       }))
//   },
//   {
//     pattern: /^spacemonk:.+\/update$/,
//     operation: ({deeplink, baseURL, formData}) =>
//       apiPut(
//         deeplinkToURL(deeplink.replace(/\/update$/, '').replace(/\/v2\//, '/')), // TODO: remove '/v2' hack
//         {body: formData}
//       ).then(({message, refreshDeeplink}) => ({ // TODO: should be 'userMessage'
//         url: deeplinkToURL(refreshDeeplink, baseURL),
//         message
//       }))
//   },
//   {
//     pattern: /^spacemonk:.+\/delete$/,
//     operation: ({deeplink, baseURL}) =>
//       apiDelete(
//         deeplinkToURL(deeplink) // TODO: should be same as other links
//       ).then(({userMessage: message, refreshDeeplink}) => ({
//         url: deeplinkToURL(refreshDeeplink, baseURL),
//         message
//       }))
//   },
//   {
//     pattern: /^spacemonk:.+\/(attach$|chat\/)/,
//     operation: () => ({
//       message: 'Currently not supported'
//     })
//   },
//   {
//     pattern: /^spacemonk:\/\/v2\/[^/]+$/,
//     operation: ({deeplink, baseURL}) => ({
//       url: deeplinkToURL(deeplink, '/list'),
//     })
//   },
//   {
//     pattern: /^spacemonk:\/\/v2\/[^/]+\/.+/,
//     operation: ({deeplink, baseURL}) => ({
//       url: deeplinkToURL(deeplink, '/details'),
//     })
//   },
//   {
//     pattern: /.*/,
//     operation: ({deeplink, baseURL}) => ({
//       url: deeplinkToURL(deeplink, baseURL),
//     })
//   },
// ];

const apiHandler = (deeplink, apiType, formBody) => {
  const apiHandlers = {
    1: apiGet,
    2: apiPost,
    3: apiPut,
    4: apiDelete,
    5: fetchDynamicJSON,
  };
  const data = apiType === 1 || apiType === 5 ? undefined : { body: formBody };
  const apiExecutor = apiHandlers[apiType]
    ? () =>
        apiHandlers[apiType](deeplinkToURL(deeplink), data).then(
          (response) => response
        )
    : () => deeplinkRegExpHandler(deeplink, apiType, formBody);

  return (apiExecutor || (() => {}))();
};

const deeplinkRegExpHandler = (
  deeplink,
  apiType,
  formBody,
  miscHandlers = {},
  miscItems = {}
) => {
  const deeplinkRoutes = [
    // {
    //   pattern: regExp,
    //   paths: [
    //     { pattern: regExp1, operation: () => {} },
    //     { pattern: regExp1, operation: () => {} },
    //   ],
    // },
    {
      pattern: /spacemonk:\/\/(.+)\/(confirm)/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) =>
            SMConfirmDialogControl.open(
              { deeplink: deeplink.replace('/confirm', '') },
              apiType,
              formBody,
              {
                ...(miscHandlers || {}),
                doneCallback: (refreshDeeplink) => {
                  if (refreshDeeplink) {
                    miscHandlers.doneCallback(refreshDeeplink);
                    SMDIalogControl.close();
                  }
                  SMConfirmDialogControl.close();
                },
              }
            ),
        },
      ],
    },
    {
      pattern: /^(http|https):\/\/(.+)/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) =>
            window.open(deeplink, '_blank'),
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/(view)$/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) =>
            SMDialogControl.open(
              { deeplink: deeplink.replace('/view', '') },
              apiType,
              formBody,
              {
                ...(miscHandlers || {}),
                doneCallback: (refreshDeeplink) => {
                  if (refreshDeeplink) {
                    miscHandlers.doneCallback(refreshDeeplink);
                    SMDIalogControl.close();
                  }
                },
              },
              { isLarge: true }
            ),
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/(add|edit)/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) =>
            SMDialogControl.open(
              { deeplink: deeplink.replace('/dialog', '') },
              apiType,
              formBody,
              miscHandlers
            ),
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/(map)\/(dialog)/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) =>
            SMDialogControl.open(
              { deeplink: deeplink.replace('/map/dialog', '') },
              apiType,
              formBody,
              miscHandlers,
              { showMap: true }
            ),
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/(prompt)/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers, miscItems) =>
            SMDIalogControl.open(
              {
                deeplink: '',
                dynamicJSON: {
                  ...(ConfirmDialogBuilder({
                    title: miscItems.title || '',
                    message: miscItems.msg,
                    submitDeeplink: deeplink.replace('/prompt', ''),
                    apiType,
                  }) || {}),
                },
              },
              apiType,
              { ...formBody },
              {
                ...(miscHandlers || {}),
                doneCallback: (refreshDeeplink) => {
                  if (refreshDeeplink) {
                    miscHandlers.doneCallback(refreshDeeplink);
                    SMDIalogControl.close();
                  }
                },
              },
              { isConfirmationDialog: true },
              {
                ...(miscItems || {}),
                uploadDeeplink: deeplink,
              }
            ),
        },
      ],
    },

    {
      pattern: /spacemonk:\/\/(.+)\/(dialog)/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) =>
            SMDialogControl.open(
              { deeplink: deeplink.replace('/dialog', '') },
              apiType,
              formBody,
              {
                ...(miscHandlers || {}),
                doneCallback: (refreshDeeplink) => {
                  if (refreshDeeplink) {
                    miscHandlers.doneCallback(refreshDeeplink);
                    SMDIalogControl.close();
                  }
                },
              }
            ),
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/submit$/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) => {
            return apiHandler(
              (deeplink || '').replace('/submit', '').replace('/v2', ''),
              2,
              formBody
            );
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/(cache)/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers, miscItems) => {
            (miscItems.localKeys || []).forEach((key) => {
              formBody[key] && persistentStore.set(key, formBody[key]);
            });
            return apiHandler(
              (deeplink || '').replace('/cache', ''),
              apiType,
              formBody
            );
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/chat$/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) => {
            apiHandler(deeplink.replace('/chat', ''), apiType)
              .then((response) => {
                SMChatDIalogControl.open(
                  { dynamicJSON: response.data },
                  apiType,
                  formBody,
                  miscHandlers
                );
              })
              .catch(miscHandlers.errorCallback || console.log);
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/chat\/\d/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) => {
            apiHandler(
              deeplink.replace(/\/\d{0,10}$/, '').replace('/v2', ''),
              2
            )
              .then((response) => {
                SMChatDIalogControl.open(
                  {
                    dynamicJSON: {
                      chatRoom: {
                        room_id: ((response || {}).data || {}).qiscusRoomId,
                      },
                    },
                  },
                  apiType,
                  formBody,
                  miscHandlers
                );
              })
              .catch(miscHandlers.errorCallback || console.log);
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/multiple-import$/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers, miscItems) => {
            miscItems.fileInputRef.current.addEventListener(
              'change',
              (event) => {
                (event.target.files || []).length > 0 &&
                  workSheetReader(
                    (event.target.files || [])[0],
                    (sheets, sheetNames) => {
                      miscItems.fileInputRef.current.value = null;
                      SMDIalogControl.open(
                        {
                          dynamicJSON: {
                            ...(SheetMappingTableBuilder({
                              submitDeeplink:
                                'spacemonk://multiple-import-mapped',
                              sheetNames: sheetNames,
                              tableKey: 'sheetColumnMap',
                              columns: miscItems.columns.filter(
                                (column) => !column.skipMapping
                              ),
                              sheetHeaderSet: (sheetNames || []).reduce(
                                (headerCollection, sheetName) => ({
                                  ...(headerCollection || {}),
                                  [sheetName]: (
                                    getSheetHeaders(
                                      (sheets || {})[sheetName]
                                    ) || []
                                  ).map((header) => ({
                                    title: header,
                                    id: header,
                                  })),
                                }),
                                {}
                              ),
                            }) || {}),
                          },
                        },
                        apiType,
                        {
                          ...formBody,
                        },
                        {
                          ...(miscHandlers || {}),
                          doneCallback: (refreshDeeplink) => {
                            refreshDeeplink &&
                              miscItems.refresh(refreshDeeplink);
                          },
                        },
                        {},
                        {
                          ...(miscItems || {}),
                          importDeeplink: deeplink,
                          sheetNames,
                          sheets,
                        }
                      );
                    }
                  );
              }
            );
            miscItems.fileInputRef.current.click();
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/multiple-import-mapped$/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers, miscItems) => {
            const bodyKey = miscItems.bodyKey;
            const titleKey = miscItems.titleKey;
            const importKey = miscItems.importKey;
            const columns = miscItems.columns;
            SMDIalogControl.open(
              {
                deeplink: '',
                dynamicJSON: {
                  ...(multiSheetVerifyTable({
                    title: formBody[miscItems.titleKey],
                    tableKey: miscItems.importKey,
                    submitDeeplink: (miscItems.importDeeplink || '').replace(
                      '/multiple-import',
                      ''
                    ),
                    columns: miscItems.columns,
                    sheets: miscItems.sheets,
                    bodyKey: miscItems.bodyKey,
                    sheetNames: ((formBody || {}).sheetColumnMap || []).map(
                      (sheet) => sheet.id
                    ),
                    sheetColumnMap: (formBody.sheetColumnMap || []).reduce(
                      (columnMap, sheet) => ({
                        ...columnMap,
                        [sheet.id]: sheet,
                      }),
                      {}
                    ),
                  }) || {}),
                },
              },
              apiType,
              {},
              {
                ...(miscHandlers || {}),
                handleDeeplink: (
                  deeplink,
                  apiType,
                  formData,
                  miscHandlers,
                  miscItems
                ) => {
                  let errorSheets = [];
                  const requestBody = {
                    ...formData,
                    [bodyKey]: Object.keys(
                      (formData || {})[bodyKey] || {} || []
                    ).map((key) => ({
                      [titleKey]: key,
                      [importKey]: (
                        ((formData || {})[bodyKey] || {})[key] || {}
                      ).rows,
                    })),
                  };
                  let importBody = (formData || {})[bodyKey];

                  Object.keys(importBody || []).forEach((sheetName) => {
                    if (
                      !(importBody[sheetName] && !isEmpty(importBody[sheetName])
                        ? (importBody[sheetName].rows || []).reduce(
                            (isRowValid, currentRow) =>
                              isRowValid &&
                              columns.reduce((isValid, currentColumn) => {
                                return (
                                  isValid &&
                                  (currentColumn.columnContentType.isRequired
                                    ? !!(currentRow || {})[currentColumn.key]
                                    : true)
                                );
                              }, true),
                            true
                          )
                        : false)
                    ) {
                      errorSheets.push(sheetName);
                    }
                  });

                  if ((errorSheets || []).length > 0) {
                    alert(
                      `Please fill in mandatory fields in the following sheets\nMandatory fields are those which have '*' in their column title${errorSheets.reduce(
                        (list, field) => `${list}\n\n - ${field}`,
                        ''
                      )}`
                    );
                    return { then: () => {} };
                  }

                  return processDeeplink(
                    deeplink,
                    apiType,
                    requestBody,
                    miscHandlers,
                    miscItems
                  );
                },
                doneCallback: (refreshDeeplink, data) => {
                  !!data &&
                    !isEmpty(data) &&
                    (miscItems.setMessage || (() => {}))(
                      data.userMessage || 'Validation Failed'
                    );
                  if (refreshDeeplink) {
                    miscHandlers.doneCallback(refreshDeeplink);
                    SMDIalogControl.close();
                  }
                },
              },
              { isLarge: true },
              {
                ...(miscItems || {}),
                importDeeplink: deeplink,
              }
            );
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/import/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers, miscItems) => {
            miscItems.fileInputRef.current.addEventListener(
              'change',
              (event) => {
                (event.target.files || []).length > 0 &&
                  workSheetReader(
                    (event.target.files || [])[0],
                    (sheets, sheetNames) => {
                      miscItems.fileInputRef.current.value = null;
                      SMDIalogControl.open(
                        {
                          dynamicJSON: {
                            ...(SheetTableMapBuilder({
                              submitDeeplink: 'spacemonk://import-mapped',
                              columns: miscItems.columns.filter(
                                (column) => !column.skipMapping
                              ),
                              sheetHeaders: (
                                getSheetHeaders(
                                  (sheets || [])[sheetNames[0]]
                                ) || []
                              ).map((header) => ({
                                title: header,
                                id: header,
                              })),
                            }) || {}),
                          },
                        },
                        apiType,
                        { ...formBody, rows: (sheets || [])[sheetNames[0]] },
                        {
                          ...(miscHandlers || {}),
                          doneCallback: (refreshDeeplink) => {
                            refreshDeeplink &&
                              miscItems.refresh(refreshDeeplink);
                          },
                        },
                        {},
                        {
                          ...(miscItems || {}),
                          importDeeplink: deeplink,
                        }
                      );
                    }
                  );
              }
            );
            miscItems.fileInputRef.current.click();
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/import-mapped$/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers, miscItems) => {
            const rows = formBody.rows
              .map((currentRow, index) => ({
                id: index,
                ...(miscItems.columns
                  .filter((column) => !column.skipMapping)
                  .reduce(
                    (row, column) => ({
                      ...row,
                      [column.key]: {
                        value: currentRow[formBody[column.key]] || undefined,
                        cellEditable: true,
                      },
                    }),
                    {}
                  ) || {}),
              }))
              .filter((row) =>
                miscItems.columns.reduce(
                  (validFlag, column) =>
                    validFlag || !!(row[column.key] || {}).value,
                  false
                )
              );
            SMDIalogControl.open(
              {
                deeplink: '',
                dynamicJSON: {
                  ...(verifyTemplateGenerator({
                    submitDeeplink: miscItems.importDeeplink.replace(
                      '/import',
                      ''
                    ),
                    columns: miscItems.columns,
                    rows,
                  }) || {}),
                },
              },
              apiType,
              { ...formBody },
              {
                ...(miscHandlers || {}),
                doneCallback: (refreshDeeplink) => {
                  if (refreshDeeplink) {
                    miscHandlers.doneCallback(refreshDeeplink);
                    SMDIalogControl.close();
                  }
                },
              },
              { isLarge: true },
              {
                ...(miscItems || {}),
                importDeeplink: deeplink,
              }
            );
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/upload/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers, miscItems) => {
            miscItems.fileInputRef.current.addEventListener(
              'change',
              (event) => {
                (event.target.files || []).length > 0 &&
                  workSheetReader(
                    (event.target.files || [])[0],
                    (sheets, sheetNames) => {
                      const importedHeaders =
                        getSheetHeaders((sheets || [])[sheetNames[0]]) || [];
                      const isTemplateMatching = miscItems.columns
                        .filter((column) => !column.skipMapping)
                        .every(
                          (element, index) =>
                            element.matchString == importedHeaders[index]
                        );
                      miscItems.fileInputRef.current.value = null;
                      if (isTemplateMatching) {
                        const updatedState = (sheets || [])[sheetNames[0]].map(
                          (currentRow, index) => ({
                            ...(miscItems.columns
                              .filter((column) => !column.skipMapping)
                              .reduce(
                                (row, column) => ({
                                  ...row,
                                  [column.key]:
                                    currentRow[column.matchString] || undefined,
                                }),
                                {}
                              ) || {}),
                          })
                        );
                        const dataCount = updatedState.length;
                        formBody.rows = [...updatedState];
                        SMDIalogControl.open(
                          {
                            deeplink: '',
                            dynamicJSON: {
                              ...(ConfirmDialogBuilder({
                                title: 'Import Data',
                                message: `The File uploaded by you contains ${dataCount} entries in total.\nClick on proceed to import the data.`,
                                submitDeeplink: deeplink.replace('/upload', ''),
                              }) || {}),
                            },
                          },
                          apiType,
                          { ...formBody },
                          {
                            ...(miscHandlers || {}),
                            doneCallback: (refreshDeeplink) => {
                              if (refreshDeeplink) {
                                miscHandlers.doneCallback(refreshDeeplink);
                                SMDIalogControl.close();
                              }
                            },
                          },
                          { isConfirmationDialog: true },
                          {
                            ...(miscItems || {}),
                            uploadDeeplink: deeplink,
                          }
                        );
                      } else {
                        SMDIalogControl.open(
                          {
                            dynamicJSON: {
                              ...(SheetTableMapBuilder({
                                submitDeeplink: 'spacemonk://upload-mapped',
                                columns: miscItems.columns.filter(
                                  (column) => !column.skipMapping
                                ),
                                sheetHeaders: (
                                  getSheetHeaders(
                                    (sheets || [])[sheetNames[0]]
                                  ) || []
                                ).map((header) => ({
                                  title: header,
                                  id: header,
                                })),
                              }) || {}),
                            },
                          },
                          apiType,
                          { ...formBody, rows: (sheets || [])[sheetNames[0]] },
                          {
                            ...(miscHandlers || {}),
                            doneCallback: (refreshDeeplink) => {
                              refreshDeeplink &&
                                miscItems.refresh(refreshDeeplink);
                            },
                          },
                          {},
                          {
                            ...(miscItems || {}),
                            uploadDeeplink: deeplink,
                          }
                        );
                      }
                    }
                  );
              }
            );
            miscItems.fileInputRef.current.click();
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/upload-mapped$/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers, miscItems) => {
            const updatedState = formBody.rows.map((currentRow, index) => ({
              ...(miscItems.columns
                .filter((column) => !column.skipMapping)
                .reduce(
                  (row, column) => ({
                    ...row,
                    [column.key]: currentRow[formBody[column.key]] || undefined,
                  }),
                  {}
                ) || {}),
            }));
            formBody.rows = updatedState;
            const dataCount = updatedState.length;

            SMDIalogControl.open(
              {
                deeplink: '',
                dynamicJSON: {
                  ...(ConfirmDialogBuilder({
                    title: 'Import Data',
                    message: `The File uploaded by you contains ${dataCount} entries in total.\nClick on proceed to import the data.`,
                    submitDeeplink: miscItems.uploadDeeplink.replace(
                      '/upload',
                      ''
                    ),
                  }) || {}),
                },
              },
              apiType,
              { ...formBody },
              {
                ...(miscHandlers || {}),
                doneCallback: (refreshDeeplink) => {
                  if (refreshDeeplink) {
                    SMDIalogControl.close();
                    miscHandlers.doneCallback(refreshDeeplink);
                  }
                },
              },
              { isConfirmationDialog: true },
              {
                ...(miscItems || {}),
                uploadDeeplink: deeplink,
              }
            );
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/(.+)\/location_picker$/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) => {
            SMLocationDIalogControl.open({}, apiType, formBody, miscHandlers);
          },
        },
      ],
    },
    {
      pattern: /spacemonk:\/\/test-dialog/,
      paths: [
        {
          pattern: /()/,
          operation: (deeplink, apiType, formBody, miscHandlers) => {
            SMDIalogControl.open({}, apiType, formBody, miscHandlers, {});
          },
        },
      ],
    },
  ];
  const currentRoute = deeplinkRoutes.find((route) =>
    route.pattern.test(deeplink)
  );
  const currentPath = ((currentRoute || {}).paths || []).find((path) =>
    path.pattern.test(deeplink.replace((currentRoute || {}).pattern, ''))
  );

  return (
    (currentPath || {}).operation ||
    (!!apiType && apiType !== 1
      ? apiHandler
      : miscHandlers.fallbackOperation || apiHandler)
  )(deeplink, apiType || 1, formBody, miscHandlers, miscItems);
};

export async function processDeeplink(
  deeplink,
  apiType,
  formData,
  miscHandlers,
  miscItems
) {
  return deeplinkRegExpHandler(
    deeplink,
    apiType,
    formData,
    miscHandlers,
    miscItems
  );
}

// export async function processDeeplink(deeplink, baseURL, formData) {
//   const handler = apiHandler.find(({pattern}) => pattern.test(deeplink));
//   return handler.operation({deeplink, baseURL, formData});
// }

export function deeplinkToURL(deeplink = '', baseURL = '') {
  return (
    deeplink &&
    // replace 'protocol:/' with `baseURL`
    deeplink
      .replace(/^[^:]+:\//, baseURL)
      // '/query/name1/value1/name2/value2/name3/value3'
      .replace(/query\/(.+)/, (m, query) =>
        // to '?name1=value1&name2=value2&name3=value3'
        query
          .split(/\//)
          .reduce(
            (qs, val, index) =>
              `${qs}${index % 2 ? '=' : index ? '&' : ''}${val}`,
            '?'
          )
      )
  );
}
